<div class="modal-container">
    <div class="modal-content">
      <h1 class="modal-title">Confirm Device Configuration</h1>
      <div class="modal-description">
        <p>Please confirm the customer and group for the device you are updating.</p>
        <div class="select_config_file_detail">
            <ul>
                <li><span class="configLable">Customer:</span>  <span class="configValues">{{binData.customer}}  </span></li>
                <li><span class="configLable">Group:</span> <span class="configValues">{{binData.group}}   </span></li>
                <li><span class="configLable">Config Version:</span> <span class="configValues">{{binData.configVersion}} </span></li>
                <li><span class="configLable">Firmware Version:</span> <span class="configValues">{{binData.fwVersion}} </span></li>
            </ul>
        </div>
      </div>
      <div class="button-container">
          <button mat-stroked-button mat-dialog-close style="color: #3A6570" type="button" class="btn-cancel"  (click)="onCancel()">Cancel</button>
          <button type="button" class="btn-confirm" (click)="onConfirm()">OK</button>
      </div>
    </div>
  </div>
  
  